import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.new_task_overlay.tags',
    viewPath: props.viewPath,
  })

  let tags = useDataValue({
    context: 'tab',
    path: 'selected.new_task_overlay.tags',
    viewPath: props.viewPath,
  })

  let tag = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(tags.filter(({ id }) => id !== tag.id))
  }
}
